import React, { useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Images } from "../../../utils/Images";
import {
  INDIAN_MOBILE_LENGTH,
  withIndianMobileInput,
} from "../../../utils/phoneValidation";

const AuthenticationTextInput = ({
  label,
  type = "text",
  value,
  onChange,
  error,
  helperText,
  placeholder = "",
  required = false,
  phoneInput = false,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
   const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
   const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)"); 


  // Define styles inside the component function
  const containerStyle = {
    position: "relative",
    marginBottom:  isMobile ? "20px" : isTablet ? "10px" : "22px",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px ",
    border: "1px solid #B9B9B8",
    borderRadius: "8px",
    fontSize:  isMobile ? "12px" : isTablet ? "13px" : "14px",
    fontFamily: "inherit",
    boxSizing: "border-box",
    outline: "none",
    height: isMobile ? "43px" : isTablet ? "48px" : "52px",
  };
  const requiredAsterisk = {
    color: "#f04951",
    marginLeft: "4px",
  };
  const iconButtonStyle = {
    position: "absolute",
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "4px",
    background: "none",
    border: "none",
    cursor: "pointer",
  };

  const iconImageStyle = {
    width: "20px",
    height: "20px",
    objectFit: "contain",
  };

  const labelStyle = {
    display: "block",
    marginBottom: isMobile ? "10px" : isTablet ? "10px" : "12px",
    fontWeight: 500,
    fontSize: isMobile ? "14px" : isTablet ? "15px" : "16px",
    color: "#1D1D1B",
  };

  const errorStyle = {
    color: "#f04951",
    fontSize: "12px",
    marginTop: "2px",
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
    
  };

  const isPhoneField = phoneInput || type === "tel";
  const inputType =
    type === "password" && showPassword ? "text" : isPhoneField ? "tel" : type;

  const handleChange = isPhoneField ? withIndianMobileInput(onChange) : onChange;

  const {
    inputMode: inputModeProp,
    maxLength: maxLengthProp,
    autoComplete: autoCompleteProp,
    ...inputRestProps
  } = props;

  return (
    <div style={containerStyle}>
      {label &&  <label style={labelStyle}>
          {label}
          {required && <span style={requiredAsterisk}>*</span>}
        </label>}
      <div style={{ position: "relative" }}>
        <input
          type={inputType}
          value={value}
          onChange={handleChange}
          style={inputStyle}
          placeholder={placeholder}
          {...inputRestProps}
          inputMode={isPhoneField ? "numeric" : inputModeProp}
          maxLength={isPhoneField ? INDIAN_MOBILE_LENGTH : maxLengthProp}
          autoComplete={isPhoneField ? "tel" : autoCompleteProp}
        />
        {type === "password" && (
          <button
            type="button"
            onClick={handleTogglePassword}
            style={iconButtonStyle}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            <img
              src={showPassword ? Images.eye : Images.eyeSlash}
              alt=""
              style={iconImageStyle}
            />
          </button>
        )}
      </div>
      {(error || helperText) && (
        <div style={errorStyle}>{error || helperText}</div>
      )}
    </div>
  );
};

export default AuthenticationTextInput;